import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ContextI18nProvider } from 'utils/i18n';
import { HelmetProvider } from 'react-helmet-async';

ReactDOM.render(
	<React.StrictMode>
		<HelmetProvider>
			<ContextI18nProvider>
				<App />
			</ContextI18nProvider>
		</HelmetProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
